import { inject, Injectable, isDevMode } from '@angular/core';
import { Subject } from 'rxjs';
import { ErrorStreamChange } from '../models/$error.model';
import { EventStreamChange } from '../models/$event.model';
import { UiService } from './ui.service';
import {take} from "rxjs/operators";
import { setDoc, addDoc, collection, Firestore} from '@angular/fire/firestore';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {environment} from "../../environments/environment";
import * as StackTrace from "stacktrace-js";
/**
 * Created by greg on 18/07/2018.
 *
 * usage:
 * Put any where there is a potential error.
 * If you want the user to know about it, add a message.
 * if there is more than one instance in one function, you can add a 'code'
 */

@Injectable({ providedIn: 'root'})
export class LogService {
    public $events: Subject<EventStreamChange> = new Subject();
    public $errors: Subject<ErrorStreamChange> = new Subject();
    public current_uid;
    public userAgent;
    private db = inject(Firestore)
    // readonly hsDataFormURL = `https://forms.hubspot.com/uploads/form/v2/${environment.hsPortalId}/${environment.hsSignupFormGUID}`;
    readonly api = `${environment.functionsURL}api/hubspot`; // this is still used for welcome email // FIXME needs rewrite to be more clear

    constructor( private ui: UiService, public http:HttpClient) {
        const w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
        this.userAgent = {
            browser:navigator.userAgent,
            screen_size:x+' x '+y,
        }
    }

    /**
     * A function that returns the promise result (or true if no promise result - careful) or null if there was an error, swallowing the error but logging it out first.  I made this because of the huge amount of code for error logs in our services.
     * @param that calling service
     * @param promise the promise to execute
     * @param func calling function
     * @param message message if errors
     */
    async executePromiseLogError<CALLER extends { _file: string }, PROMISE_RETURN>(that: CALLER, promise: Promise<PROMISE_RETURN>, func: string, message: string): Promise<PROMISE_RETURN | true | null> {
      try {
        const result = await promise
        return result === null || result === undefined ? true : result
      } catch (error) {
        console.error(error)
        console.log(error)
        this.error({
          file: that._file,
          function: func,
          message: message,
          error
        })
        return null
      }
    }

    makeErrorFunction(errorObject: ErrorStreamChange) {
      return error => this.error({...errorObject, error })
    }
    error(error: ErrorStreamChange) {
        if (this.current_uid) {
            error.uid = this.current_uid;
        }
        if(!error.file) error.file = error.data.file || 'file not recorded'
        if(!error.function) error.function = error.data.function || 'function not recorded'
        error.path = error.file + ': '+ error.function + (error.code !== undefined ? ' '+error.code : '');
        error.frontend_version = this.ui.version;
        error.isDevMode = isDevMode();
        if(error.response && error.response.code === 'permission-denied') console.error('Permission Error @ ', error.path, error)
        if(!error.error) error.error = new Error();
        StackTrace.fromError(error.error).then( stackframes =>{
          error.trace = stackframes.map(function(sf) {
            return sf.toString();
          }).join('\n');
          error.error = true;
          error = JSON.parse(JSON.stringify(error))
          error.userAgent = this.userAgent;
          if(!error.level) error.level = 1;
          if(!error.timestamp) error.timestamp = new Date();
          if(error.message) {
            // this.$events.next({type:'error',action:error.type || 'standard',data:error})
            this.ui.addUiMessage({
              type:'error',
              action: 'standard',
              message: error.message,
              code: error.code || null
            })
          }
          console.log('error ', error);
          addDoc(collection(this.db,'_errors'), error).then(()=>{ console.log('added error' )}).catch(console.error);
        }).catch(console.error)
        /*.then(_=>{console.log('logged')},error=>{ console.log('error longing ',error)}*/
    }
    message(message){
      this.$events.next({type:'message',action:'standard',data:message})
    }
    stat(collection_vaules_pairs:any){
        // const url = `${this.api}/add-stats`;
        // this.http.post(url, { stats:collection_vaules_pairs })
        //     .pipe(take(1))
        //     .subscribe(()=>{ },(response)=>{
        //         this.error({file:'log.service.ts',function:'stat',data:{stats:collection_vaules_pairs},response})
        //     })
        // console.log('stats collection_vaules_pairs ',collection_vaules_pairs)
    }
    stackTraceErr(err){
      console.error(err)
    }
    // hsAddContact(contact) {
    //     const contact_obj = {properties: {
    //         email: contact.email,
    //         firstname: contact.firstName,
    //         lastname: contact.lastName
    //       }
    //     };
    //     const url = `${this.api}/hs-add-contact`;
    //     setTimeout(() => {
    //         this.http.post(url, {contact_obj}).pipe(take(1)).subscribe(ret => console.log(ret));
    //     }, 10000);
    // }
    // hsUpdateContact(email,properties) {
    //     const contact_obj = {properties};
    //     const url = `${this.api}/hs-update-contact`;
    //     this.http.post(url, {contact_obj, email}).pipe(take(1)).subscribe(ret => console.log(ret));
    // }
    nonHsSignUpForm(contact) {
        console.log('nonHsSignUpForm ')
        const data = {joi_uid: contact.uid, email: contact.email, firstname: contact.firstName, lastname: contact.lastName };
        const url = `${this.api}/regular-sign-up`;
        
        setTimeout(() => {
            this.http.post(url, data).pipe(take(1)).subscribe(ret => console.log({ret}));
        }, 10000);
    }
    hsSignUpForm(contact) {
        console.log('hsSignUpForm ')
        const data = {joi_uid: contact.uid, email: contact.email, firstname: contact.firstName, lastname: contact.lastName,
            portalId: environment.hsPortalId, formId: environment.hsSignupFormGUID, signUp: true};
        const url = `${this.api}/hs-sign-up`;
        const hubspotutk_arr = document.cookie.match(/hubspotutk=(.*?);/);
        if (hubspotutk_arr && hubspotutk_arr[1]) {
            data['hubspotutk'] = hubspotutk_arr[1];
        }
        setTimeout(() => {
            this.http.post(url, data).pipe(take(1)).subscribe(ret => console.log({ret}));
        }, 10000);
    }
    hsProfileUpdate(u) {
        const data = {email: u.email, jobtitle: u.title || '', company: u.company || '',
            about_me: u.aboutMe || '', mobilephone: u.phone || '', firstName: u.firstName || '', lastName: u.lastName || '',
            portalId: environment.hsPortalId, formId: environment.hsProfileFormGUID, signUp: false};
        const url = `${this.api}/hs-sign-up`;
        const hubspotutk_arr = document.cookie.match(/hubspotutk=(.*?);/);
        // console.log(data);
        if (hubspotutk_arr && hubspotutk_arr[1]) {
            data['hubspotutk'] = hubspotutk_arr[1];
            this.http.post(url, data).pipe(take(1)).subscribe(ret =>{}, console.error);
        }else{
          console.error('cookie does not exist')
        }
    }
}
